import type { SkjulSamtaleStatus } from "enums/skjulSamtaleStatus";

export const OPPGAVE_ENDPOINT_FULL =
  "/proxy/oppgaveinternal/innbygger/oppgave/v2";

export const OPPGAVE_ENDPOINT = "oppgaveinternal/innbygger/oppgave/v2";

export const OPPGAVE_INTERNAL = "oppgaveinternal";

export const SKJUL_FOR_FULLMAKT = "skjulForFullmakt";

export const CHANGELOG = "changelog";

export interface BaseDokumentQueryV1Request {
  DokumentGuid: any;
}
export interface BaseGetDokumentFilStreamV1Request extends BaseDokumentQueryV1Request {
  DownloadMode: boolean;
}

export interface SkjulOppgaveForFullmaktResponse {
  SkjulSamtaleStatus: SkjulSamtaleStatus;
}
